"use client";

import { c as _c } from "react/compiler-runtime";
import { memo, useState } from "react";
const TRUNCATE_LENGTH = 80;

/** Render inline markdown: **bold** and `code`. */
function renderMarkdown(text: string) {
  const parts = text.split(/(\*\*[^*]+\*\*|`[^`]+`)/g);
  return parts.map((part, i) => {
    if (part.startsWith("**") && part.endsWith("**")) {
      return <strong key={i} className="text-ds-text-secondary font-semibold">
          {part.slice(2, -2)}
        </strong>;
    }
    if (part.startsWith("`") && part.endsWith("`")) {
      return <code key={i} className="bg-ds-neutral-200 text-ds-text-secondary dark:bg-ds-neutral-700 text-2xs rounded px-1 py-0.5 font-mono">
          {part.slice(1, -1)}
        </code>;
    }
    return <span key={i}>{part}</span>;
  });
}

/**
 * Renders a field description with inline markdown support.
 * Long descriptions are truncated to the first sentence with a "Learn more" toggle.
 */
function FieldDescriptionInner(t0) {
  const $ = _c(17);
  const {
    text,
    id
  } = t0;
  const [expanded, setExpanded] = useState(false);
  const firstSentenceEnd = text.indexOf(". ");
  let t1;
  if ($[0] !== firstSentenceEnd || $[1] !== text) {
    t1 = firstSentenceEnd > 0 ? text.slice(0, firstSentenceEnd + 1) : text;
    $[0] = firstSentenceEnd;
    $[1] = text;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const shortText = t1;
  const isLong = shortText.length < text.length && text.length > TRUNCATE_LENGTH;
  if (!isLong) {
    let t2;
    if ($[3] !== text) {
      t2 = renderMarkdown(text);
      $[3] = text;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    let t3;
    if ($[5] !== id || $[6] !== t2) {
      t3 = <p id={id} className="text-ds-text-subtle dark:text-ds-text-disabled text-xs">{t2}</p>;
      $[5] = id;
      $[6] = t2;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    return t3;
  }
  const t2 = expanded ? text : shortText;
  let t3;
  if ($[8] !== t2) {
    t3 = renderMarkdown(t2);
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setExpanded(_temp);
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = expanded ? "Show less" : "Learn more";
  let t6;
  if ($[11] !== t5) {
    t6 = <button type="button" onClick={t4} className="inline text-blue-500 hover:text-blue-400">{t5}</button>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== id || $[14] !== t3 || $[15] !== t6) {
    t7 = <p id={id} className="text-ds-text-subtle dark:text-ds-text-disabled text-xs">{t3}{" "}{t6}</p>;
    $[13] = id;
    $[14] = t3;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}
function _temp(v) {
  return !v;
}
export const FieldDescription = memo(FieldDescriptionInner);